import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { UserProfileErrorComponent } from "~/features/profile/components/UserProfileErrorComponent";
import { UserProfileSkeleton } from "~/features/profile/components/UserProfileSkeleton";
import { UserProfileTemplate } from "~/features/profile/UserProfileTemplate";
import {
  publicImagesQueryOptions,
  userProfileQueryOptions,
} from "~/lib/queryOptions/userProfileQueryOptions";

// 遷移元を示す search param。"instant-call"（さがす画面の今すぐ通話一覧）と
// "busy-call"（通話中モーダル）から来たときだけ通話可能の強調演出を出す。
// pos は遷移元セクション内の 0 始まりのカード位置（計測用）。
const profileSearchSchema = z.object({
  from: z
    .enum([
      "talked-before",
      "instant-call",
      "high-review",
      "preference-match",
      "meet-people",
      "sadistic",
      "masochistic",
      "ranking",
      "busy-call",
    ])
    .optional(),
  pos: z.number().int().nonnegative().optional(),
});

const ProfileUserPage = () => {
  const { userId } = Route.useParams();
  const { from, pos } = Route.useSearch();
  return (
    <UserProfileTemplate
      userId={userId}
      highlightInstantCall={from === "instant-call" || from === "busy-call"}
      from={from}
      position={pos}
    />
  );
};

export const Route = createFileRoute("/_authenticated/profile/$userId")({
  validateSearch: profileSearchSchema,
  loader: ({ context: { queryClient }, params: { userId } }) =>
    Promise.all([
      queryClient.ensureQueryData(userProfileQueryOptions(userId)),
      queryClient.ensureQueryData(publicImagesQueryOptions(userId)),
    ]),
  pendingMs: 200,
  pendingMinMs: 300,
  pendingComponent: UserProfileSkeleton,
  errorComponent: UserProfileErrorComponent,
  component: ProfileUserPage,
});
